export const termsContent = `
<h2>Allmänna villkor</h2>
<p><strong>Våra generella villkor</strong></p>

<h3>1. Om tjänsten</h3>
<p>Ziplink är en tjänst för köp av livsmedel på din arbetsplats. Ziplink butiken är öppen för dig dygnet runt, varje dag i veckan (om inte annat avtalats parterna emellan). Du har tillgång till ett brett och varierat sortiment av mellanmål, kalla drycker, frukostmackor och kylda måltider vid beställning. Tjänsten omfattas i allmänhet av köp- och medlemsvillkoren nedan. Dessa köp-och medlemsvillkor börjar gälla från och med kontots skapande.</p>

<h4>1.1 Parterna</h4>
<p>Köp- och tjänstevillkoren reglerar avtalet mellan dig som kund (nedan: du, kunden) och Ziplink AB (nedan: vi, Ziplink). Tjänsten tillhandahålls i samarbete med arbetsplatsens arbetsgivare.</p>

<h4>1.2 Avtalets giltighet</h4>
<p>Köp- och medlemsvillkoren utgör parternas huvudsakliga reglering av de frågor som omfattas av dessa villkor. Ziplink förbehåller sig rätten att uppdatera och revidera dessa köp- och medlemsvillkor. Därför ber vi dig alltid kontrollera gällande villkor på <a href="https://www.ziplink.se" target="_blank">www.Ziplink.se</a>. Vid större förändringar av köp- och medlemsvillkoren meddelar vi kunden per e-post senast 14 dagar innan ändringarna träder i kraft.</p>

<h4>1.3 Kontaktuppgifter</h4>
<p>Tjänsten ägs och drivs av Ziplink AB, org.nr. 559459-8350, (nedan ”Ziplink”). Utjordsvägen 11, 802 91 Gävle. Har du frågor om köp- och medlemsvillkoren eller om vår integritetspolicy, hur vi hanterar dina personuppgifter eller har ett annat kundtjänstärende, kontakta oss gärna per e-post: <a href="mailto:info@Ziplink.se">info@Ziplink.se</a>. Aktuella kontaktuppgifter till oss finns även på <a href="https://www.ziplink.se" target="_blank">www.Ziplink.se</a>. På vår hemsida finns även vår integritetspolicy.</p>

<h3>2. Att handla hos Ziplink</h3>
<p>För information om vilka personuppgifter vi behandlar och syftet med behandlingen hänvisar vi till vår integritetspolicy, du finner denna på vår hemsida.</p>

<h4>2.1 Uppgifternas riktighet</h4>
<p>Uppgifterna vid betalning ska vara korrekta och du är skyldig att uppdatera dessa uppgifter om de vid någon tidpunkt skulle förändras. För att uppdatera dina uppgifter vänligen kontakta oss på <a href="mailto:info@Ziplink.se">info@Ziplink.se</a>.</p>

<h4>2.2 Behandling av personuppgifter</h4>
<p>När du köper våra produkter och använder våra tjänster kan du direkt eller indirekt komma att ge oss information om dig själv på ett antal olika sätt...</p>

<h3>3. Betalning</h3>
<p>Ziplink eller arbetsplatsens arbetsgivare förbehåller sig rätten att avsluta/spärra konton vid missbruk eller obetalda köp.</p>

<h4>3.1 Betalning av köp</h4>
<p>Du som kund är skyldig att se till att vald vara finns tillgänglig i Kylboxen...</p>

<h4>3.2 Betalningsansvar</h4>
<p>Som kund finns ett personligt betalningsansvar för de köp som görs i våra boxar...</p>

<h4>3.3 Kameraövervakning</h4>
<p>För att säkerställa en hög säkerhetsnivå och motverka brott samt svinn, har vi implementerat ett system för videoinspelning...</p>

<h3>4. I händelse av stöld eller inlämnande av otjänliga uppgifter</h3>
<p>Om personuppgifter förvanskas, manipuleras eller på liknande sätt ändras i syfte för brottsligt ändamål eller om stöld sker...</p>

<h3>5. Livsmedelsfrågor</h3>
<h4>5.1 Matallergier</h4>
<p>Vårt sortiment kan innehålla nötter och andra allergener...</p>

<h4>5.2 Livsmedelsupplysning</h4>
<p>Som kund har du fri tillgång till vår kundtjänst som svarar på dina frågor...</p>

<h4>5.3 Reklamationer</h4>
<p>I händelse av reklamation, exempelvis om en vara har passerat bäst före datum...</p>

<h4>5.4 Ångerrätt</h4>
<p>Den lagstadgade ångerrätten gäller inte vid köp av livsmedel från Ziplink...</p>

<h3>6. Övrigt</h3>
<h4>6.1 Förändring i tjänstens innehåll</h4>
<p>Ziplink äger rätt att genomföra förändringar beträffande pris och/eller tjänstens innehåll...</p>

<h4>6.2 Överlåtelse av rättigheter och skyldigheter</h4>
<p>Ziplink förbehåller sig rätten att överlåta sina rättigheter och skyldigheter enligt detta avtal...</p>
`;
